import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NotificationModel } from '../notification.models';

@Component({
  selector: 'app-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss']
})
export class MessageItemComponent {
  @Input() message: NotificationModel;
  @Output() clickCheckbox = new EventEmitter<boolean>();
  @Output() clickCard = new EventEmitter<boolean>();

  clickCheck(event) {
    event.stopPropagation();
    this.message.checked = !this.message.checked;
    this.clickCheckbox.emit(this.message.checked);
  }
}
